import styled from 'styled-components';
import ThankYouFailSvg from '../../assets/hotels/bkng-failed.svg';

const ThankYouFailImg = styled(ThankYouFailSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '29.6rem'};
  height: ${props => props.height || '19.9rem'};
  margin: ${props => props.margin};
`;

export default ThankYouFailImg;
